import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type { PaginatedRequestResponse, RequestResponse, User } from '@/types';

export const fetchUsers = async () => {
  const response = await axiosInstance<PaginatedRequestResponse<User[]>>(
    endpoints.user
  );
  return response.data.data.data;
};

export const fetchUser = async (id: string) => {
  const response = await axiosInstance<RequestResponse<User>>(
    `${endpoints.user}/${id}`
  );
  return response.data.data;
};
